<div class="loading" *ngIf="!chartRenderData">
    <span>Loading Chart Component...</span>
</div>
<div class="chart-dialog-container" *ngIf="chartRenderData">
    <div class="field-info">
        <span class="field-heading">{{fieldName}}</span>
        <span class="asset-reference" *ngIf="assetRef">[{{assetRef}}]</span>
    </div>
    <gea-line-chart  [data]="chartRenderData" [chartOptions]="lineChartOptions"></gea-line-chart>
</div>